<div data-testid="task-detail-task-detail-header" class="task-detail-header">

  <!-- Loading indicator for SUS amount updates -->
  <dx-load-panel
    [visible]="isSavingSUSAmount"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    message="Updating amount and parent task..."
    shadingColor="rgba(0,0,0,0.4)">
  </dx-load-panel>

  <dx-box data-testid="task-detail-task-detail-header-box" direction="row" width="100%" justify="space-between" class="task-detail-header-box">
    <!-- Left side: Breadcrumb -->
    <dxi-item [ratio]="3" [shrink]="1">
      <div data-testid="task-detail-breadcrumb" class="breadcrumb">
        <span class="breadcrumb-link">Tasks</span>
        <span class="breadcrumb-separator">›</span>
        <span class="breadcrumb-current">
           {{ selectedSectionIndex !== null ? sections[selectedSectionIndex] : 'Task Detail' }} </span>
      </div>
    </dxi-item>

    <!-- Right side: Buttons -->
    <dxi-item [ratio]="2" [shrink]="1" text-align="right">
      <div data-testid="task-detail-header-buttons" class="header-buttons custom-btn">
        <dx-button data-testid="task-detail-ml-2" icon="close" stylingMode="text" class="ml-2 close-button red"
          (onClick)="onCancelClick($event)"></dx-button>
      </div>
    </dxi-item>
  </dx-box>
  <form #formElement class="task-detail-form" (submit)="onSubmit($event)">
  <dx-accordion data-testid="accordion-container-task-detail"  (onSelectionChanged)="onAccordionSelectionChanged($event)" #accordion [dataSource]="sections" [collapsible]="false"
    [multiple]="false" [animationDuration]="300" [(selectedIndex)]="selectedSectionIndex"
    id="accordion-container-task-detail" class="accordion-left-arrow">
    <div *dxTemplate="let section of 'title'">
      <div data-testid="task-detail-header" class="header" [ngClass]="{ 'urgent-task-details-header': section === 'Task Details' && isUrgentTask() }">{{ section + ' - ' + (selectedTask?.taskId || '') }}</div>
    </div>
    <div *dxTemplate="let section of 'item'">
      <div *ngIf="section == 'Task Details'">
        <dx-form data-testid="task-detail-form" [formData]="taskToEdit" *ngIf="taskToEdit != null" [colCount]="5" [colCountByScreen]="{ xs: 1, sm: 1, md: 1, lg: 5 }">
          <dxi-item [colSpan]="2">
            <!-- <ul> -->
            <div>
              <div data-testid="task-detail-two-column-grid" class="two-column-grid">
                <!-- Dynamic fields -->
                <div data-testid="task-detail-data-field" *ngFor="let key of objectKeys" class="data-field full-width">
                  <div data-testid="task-detail-field-label" class="field-label">
                    <b>{{ getTaskFieldLabel(key) }}:</b>
                  </div>
                  <div data-testid="task-detail-field-value"
                       [class.field-value]="true"
                       [class.tooltip-trigger]="shouldShowTooltipIcon(key)"
                       *ngIf="key.toLowerCase() === 'name'"
                       (mouseenter)="shouldShowTooltipIcon(key) ? showTooltip() : null"
                       (mouseleave)="shouldShowTooltipIcon(key) ? hideTooltip() : null"
                       [style.cursor]="shouldShowTooltipIcon(key) ? 'help' : 'default'">
                    {{ taskToEdit[key] }}
                    <i *ngIf="shouldShowTooltipIcon(key)" class="dx-icon dx-icon-info" style="margin-left: 6px; font-size: 14px; color: #337ab7; cursor: help;"></i>
                  </div>
                  <div data-testid="task-detail-field-value" class="field-value"
                       *ngIf="key.toLowerCase() !== 'name'"
                       [style.cursor]="'default'">
                    {{ taskToEdit[key] }}
                  </div>
                </div>

                <!-- Mark As Complete -->
                <div data-testid="task-detail-complete-field" class="data-field full-width">
                  <div data-testid="task-detail-field-label" class="field-label">
                    <b>Mark As Complete:</b>
                  </div>
                  <div data-testid="task-detail-field-value" class="field-value">
                    <div style="display: flex; align-items: center;">
                      <dx-check-box data-testid="task-detail-check-box" [value]="markAsComplete" (onValueChanged)="onCompleteChanged($event)" [disabled]="!isCompleteable"></dx-check-box>
                    </div>
                  </div>
                </div>

                <!-- Mark As N/A -->
                <!-- <div data-testid="task-detail-na-field" class="data-field full-width">
                  <div data-testid="task-detail-field-label" class="field-label">
                    <b>Mark As N/A:</b>
                  </div>
                  <div data-testid="task-detail-field-value" class="field-value">
                    <div style="display: flex; align-items: center;">
                      <dx-check-box data-testid="task-detail-na-check-box" [value]="notApplicable" (onValueChanged)="onNotApplicableChanged($event)" [disabled]="!isCompleteable"></dx-check-box>
                    </div>
                  </div>
                </div> -->

                <!-- Due Date -->
                <div data-testid="task-detail-data-field" class="data-field full-width">
                  <div data-testid="task-detail-field-label" class="field-label"><b>Due Date:</b></div>
                    <div data-testid="task-detail-field-value" class="field-value">
                    <dx-date-box data-testid="task-detail-date-box" (onValueChanged)="onDueDateValueChanged($event)" [(value)]="taskToEdit['dueDate']" [displayFormat]="dateDisplayFormat" type="date" [disabled]="!isEditable || !taskToEdit.parentId || taskToEdit.status === 'Closed' || taskToEdit.status === 'Rejected'">
                    </dx-date-box>
                    </div>
                </div>

                 <!-- Assigned User -->
                <div data-testid="task-detail-data-field" class="data-field full-width">
                  <div data-testid="task-detail-field-label" class="field-label"><b>Assigned User:</b></div>
                  <div data-testid="task-detail-field-value" class="field-value">
                    <div style="display: flex; align-items: center;">
                      <dx-select-box data-testid="task-detail-w-100" class="w-100" [(value)]="taskToEdit['assignedUserId']" [items]="allUsers" [valueExpr]="userIdExpr" [displayExpr]="userNameExpr"
                        searchMode="contains" [searchEnabled]="true" (onValueChanged)="onSelectValueChanged($event)" [disabled]="!taskToEdit.parentId || taskToEdit.status === 'Closed' || taskToEdit.status === 'Rejected'">
                      </dx-select-box>
                    </div>
                  </div>
                </div>

              </div>
            </div>

          </dxi-item>
          <dxi-item [colSpan]="3">

            <div data-testid="task-detail-data-field" class="data-field full-width">
              <div data-testid="task-detail-field-label" class="field-label mb-1"><b>Data:</b></div>
              <span
                class="copy-icon"
                (click)="copyTaskDataToClipboard()"
                title="Copy task data to clipboard"
                style="position: absolute; right: 10px; cursor: pointer; padding: 5px; z-index: 10;">
                <i class="dx-icon dx-icon-copy" style="font-size: 16px; color: #666;"></i>
              </span>
            </div>
            <div data-testid="task-detail-data-field" class="data-field full-width" style="position: relative;">
            <div data-testid="task-detail-desc-textarea" class="desc-textarea">

              <div *ngFor="let item of taskToEdit.prettifiedTaskDataArray" class="task-data-row" style="display: grid; grid-template-columns: minmax(250px, 30%) 1fr; gap: 15px; margin-bottom: 10px; align-items: start;">
                    <div data-testid="task-detail-field-key" class="field-key" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; font-weight: bold;">{{ getFieldLabel(item.key) }}</div>
                    <div style="min-width: 0;">
                    <div *ngIf="isDescriptionField(item.key)">
                        <!-- Show editable textarea for editable description fields (e.g., AVS) -->
                      <div *ngIf="isFieldEditable(item.key) && isEditable" data-testid="task-detail-description-editable" class="description-value">
                        <dx-text-area
                          [value]="(item.value || []).join('\n')"
                          (onValueChanged)="onEditableFieldValueChanged(item.key, $event.value)"
                          (onFocusOut)="onEditableFieldFocusOut(item.key)"
                          (onEnterKey)="onEditableFieldEnterKey(item.key, $event)"
                          [disabled]="!isEditable"
                          [ngClass]="{'edited-field': hasFieldBeenEdited(item.key)}"
                          height="150px"
                          width="100%">
                        </dx-text-area>
                      </div>
                      <!-- Show readonly textarea for non-editable description fields -->
                      <div *ngIf="(!isFieldEditable(item.key) || !isEditable)" data-testid="task-detail-description-value" class="description-value">
                        <textarea data-testid="task-detail-description-textarea" class="description-textarea" readonly [value]="(item.value || []).join('\n')" style="width: 100%; min-height: 80px; max-height: 200px; overflow-y: auto; white-space: pre-wrap; word-wrap: break-word; resize: vertical; border: 1px solid #ccc; padding: 8px; font-family: inherit; font-size: inherit; box-sizing: border-box;">
                        </textarea>
                      </div>
                    </div>
                  <div data-testid="task-detail-field-values" class="field-values">
                    <!-- Show truncated for non-description fields -->
                    <div *ngIf="!isDescriptionField(item.key)">
                      <!-- Show editable input if field is in editable list -->
                      <div *ngIf="isFieldEditable(item.key) && isEditable">
                        <!-- Currency format -->
                        <dx-number-box data-testid="task-detail-number-box"
                          *ngIf="getFieldFormat(item.key) === 'currency'"
                          [value]="getFieldValue(item.key)"
                          (onValueChanged)="onEditableFieldValueChanged(item.key, $event.value)"
                          (onFocusOut)="onEditableFieldFocusOut(item.key)"
                          (onEnterKey)="onEditableFieldEnterKey(item.key, $event)"
                          [disabled]="!isEditable"
                          [ngClass]="{'edited-field': hasFieldBeenEdited(item.key)}"
                          valueChangeEvent="input"
                          format="#,##0.00"
                          [step]="0"
                          width="100%">
                        </dx-number-box>
                        <!-- Number format -->
                        <dx-number-box data-testid="task-detail-number-box-1"
                          *ngIf="getFieldFormat(item.key) === 'number'"
                          [value]="getFieldValue(item.key)"
                          (onValueChanged)="onEditableFieldValueChanged(item.key, $event.value)"
                          (onFocusOut)="onEditableFieldFocusOut(item.key)"
                          (onEnterKey)="onEditableFieldEnterKey(item.key, $event)"
                          [disabled]="!isEditable"
                          [ngClass]="{'edited-field': hasFieldBeenEdited(item.key)}"
                          valueChangeEvent="input"
                          width="100%">
                        </dx-number-box>
                        <!-- Date format -->
                        <dx-date-box data-testid="task-detail-date-box"
                          *ngIf="getFieldFormat(item.key) === 'date'"
                          [value]="getFieldValue(item.key)"
                          (onValueChanged)="onEditableFieldValueChanged(item.key, $event.value)"
                          (onFocusOut)="onEditableFieldFocusOut(item.key)"
                          (onEnterKey)="onEditableFieldEnterKey(item.key, $event)"
                          [disabled]="!isEditable"
                          [ngClass]="{'edited-field': hasFieldBeenEdited(item.key)}"
                          type="date"
                          [displayFormat]="dateDisplayFormat"
                          width="100%">
                        </dx-date-box>
                        <!-- Select/Dropdown format -->
                        <dx-select-box data-testid="task-detail-select-box"
                          *ngIf="getFieldFormat(item.key) === 'select'"
                          [value]="getFieldValue(item.key)"
                          [dataSource]="loadFieldDataSource(item.key) | async"
                          valueExpr="name"
                          displayExpr="name"
                          (onValueChanged)="onSelectFieldValueChanged(item.key, $event.value, $event.component.option('selectedItem'), $event.previousValue)"
                          [disabled]="!isEditable"
                          [ngClass]="{'edited-field': hasFieldBeenEdited(item.key)}"
                          [searchEnabled]="true"
                          [showClearButton]="true"
                          placeholder="Select..."
                          width="100%">
                        </dx-select-box>
                        <!-- Loan numbers grid format -->
                        <dx-data-grid data-testid="task-detail-loan-numbers-grid"
                          *ngIf="getFieldFormat(item.key) === 'loan-numbers-grid'"
                          [dataSource]="loanNumbersGridRows"
                          keyExpr="key"
                          [showBorders]="true"
                          [columnAutoWidth]="true"
                          [rowAlternationEnabled]="false"
                          [showColumnLines]="false"
                          (onInitialized)="onLoanNumbersGridInitialized($event)"
                          (onInitNewRow)="onLoanNumberInitNewRow($event)"
                          (onRowInserted)="onLoanNumbersGridRowCommitted()"
                          (onRowUpdated)="onLoanNumbersGridRowCommitted()"
                          (onRowRemoved)="onLoanNumbersGridRowCommitted()">
                          <dxo-editing
                            mode="row"
                            [allowAdding]="false"
                            [allowUpdating]="true"
                            [allowDeleting]="true"
                            [confirmDelete]="false">
                          </dxo-editing>
                          <dxo-toolbar [visible]="false"></dxo-toolbar>
                          <dxi-column dataField="loanNumber" caption="Loan Number" dataType="string" headerCellTemplate="loanNumberHeaderTpl">
                            <dxi-validation-rule
                              type="custom"
                              message="This loan number has already been added"
                              [validationCallback]="isLoanNumberDuplicate.bind(this)"
                              [reevaluate]="true">
                            </dxi-validation-rule>
                          </dxi-column>
                          <div *dxTemplate="let col of 'loanNumberHeaderTpl'" style="overflow:hidden">
                            <button
                              type="button"
                              title="Add loan number"
                              aria-label="Add loan number"
                              (click)="addLoanNumberRow()"
                              style="float:right;cursor:pointer;font-size:14px;border:none;background:none;padding:0">
                              <i class="dx-icon dx-icon-add"></i>
                            </button>
                            <span style="font-size:12px">Loan Number</span>
                          </div>
                        </dx-data-grid>
                        <!-- Fed reference numbers grid format -->
                        <dx-data-grid data-testid="task-detail-text-input-grid"
                          *ngIf="getFieldFormat(item.key) === 'text-input-grid'"
                          [dataSource]="fedReferenceGridRows"
                          keyExpr="key"
                          [showBorders]="true"
                          [columnAutoWidth]="true"
                          [rowAlternationEnabled]="false"
                          [showColumnLines]="false"
                          (onInitialized)="onFedReferenceGridInitialized($event)"
                          (onInitNewRow)="onFedReferenceInitNewRow($event)"
                          (onRowInserted)="onFedReferenceGridRowCommitted()"
                          (onRowUpdated)="onFedReferenceGridRowCommitted()"
                          (onRowRemoved)="onFedReferenceGridRowCommitted()">
                          <dxo-editing
                            mode="row"
                            [allowAdding]="false"
                            [allowUpdating]="true"
                            [allowDeleting]="true"
                            [confirmDelete]="false">
                          </dxo-editing>
                          <dxo-toolbar [visible]="false"></dxo-toolbar>
                          <dxi-column dataField="reference" caption="Fed Reference #" dataType="string" headerCellTemplate="fedRefHeaderTpl">
                          </dxi-column>
                          <div *dxTemplate="let col of 'fedRefHeaderTpl'" style="overflow:hidden">
                            <i class="dx-icon dx-icon-add"
                               title="Add Fed Reference #"
                               (click)="addFedReferenceRow()"
                               style="float:right;cursor:pointer;font-size:14px"></i>
                            <span style="font-size:12px">Fed Reference #</span>
                          </div>
                        </dx-data-grid>
                        <!-- Text format (default) -->
                        <dx-text-box data-testid="task-detail-text-box"
                          *ngIf="!getFieldFormat(item.key) || getFieldFormat(item.key) === 'text'"
                          [value]="getFieldValue(item.key)"
                          (onValueChanged)="onEditableFieldValueChanged(item.key, $event.value)"
                          (onFocusOut)="onEditableFieldFocusOut(item.key)"
                          (onEnterKey)="onEditableFieldEnterKey(item.key, $event)"
                          [disabled]="!isEditable"
                          [ngClass]="{'edited-field': hasFieldBeenEdited(item.key)}"
                          valueChangeEvent="input"
                          width="100%">
                        </dx-text-box>
                      </div>
                      <!-- Show read-only truncated text for non-editable fields -->
                      <div *ngIf="!isFieldEditable(item.key) || !isEditable">
                        <ng-container *ngFor="let line of item.value">
                          <div *ngIf="shouldRenderUrgentBadge(item.key, line); else standardTaskDetailValue"
                               data-testid="task-detail-urgent-badge"
                               class="urgent-badge task-detail-urgent-badge">
                            Yes
                          </div>
                          <ng-template #standardTaskDetailValue>
                            <div data-testid="task-detail-truncated-text"
                                 class="truncated-text"
                                 [title]="shouldFormatFieldValue(item.key) ? (line | formatbooleannumbersdates) : line">
                              {{ getTruncatedText(shouldFormatFieldValue(item.key) ? (line | formatbooleannumbersdates) : line, 45) }}
                            </div>
                          </ng-template>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                  </div>
                </div>
            </div>
            </div>

          </dxi-item>
          <dxi-item itemType="empty" [colSpan]="2"></dxi-item>
            <dxi-item class="mt-1" [colSpan]="3">
            <!-- Assigned User -->
            <div data-testid="task-detail-data-field" class="data-field full-width">
              <div data-testid="task-detail-field-value" class="field-value">
                <div data-testid="task-detail-view-attach" class="view-attach">
                  <dx-button data-testid="task-detail-custom-btn"
                  (onClick)="openUrlInNewTab()"
                  class="custom-btn justify-content-end"
                  icon="file"
                  text="View Attachments"
                  [disabled]="!hasAttchments">
                  </dx-button>
                </div>
              </div>
            </div>
            </dxi-item>

          <dxi-item [colSpan]="5" clas="mt-1">
            <app-file-upload [fileUploadMode]="'instantly'" (onFileRemoveEventEmitter)="onFileRemove($event)" (onFileUploadEventEmitter)="onFileUpload($event)" />
          </dxi-item>
      </dx-form>
      <div data-testid="task-detail-action-buttons" class="action-buttons">
        <dx-form data-testid="task-detail-form-2" [formData]="taskToEdit" [colCount]="2" (onSubmit)="onSubmit($event)">
          <dxi-item [colSpan]="1" cssClass="user-button detail-submit mb-1 mt-1" horizontalAlignment="right"
            itemType="button" [buttonOptions]="buttonCancelOptions"></dxi-item>
          <dxi-item [colSpan]="1" cssClass="user-button mb-1 mt-1"  horizontalAlignment="right" itemType="button"
            [buttonOptions]="buttonEditorOptions"></dxi-item>
        </dx-form>
      </div>
        <!-- <div>

        </div>
        <div data-testid="task-detail-task-detail" class="task-detail">
          <form #formElement (submit)="onSubmit($event)">
            <dx-form data-testid="task-detail-form-1" [formData]="taskToEdit" width="100%" [colCount]="2">





              <dxi-item [colSpan]="2"> Description

                <div *ngIf="taskToEdit != null">
                    <div *ngFor="let l of taskToEdit.prettifiedTaskDataArray">
                      <div data-testid="task-detail-field-label" class="dx-field-label"><b>{{ getFieldLabel(l.key) }}:</b></div>
                      <div data-testid="task-detail-field-label" class="dx-field-label">{{ l.value }} &nbsp; </div>
                    </div>
                </div>
              </dxi-item>

            <dxi-item
              [colSpan]="2"
                labelMode="static"
                [editorOptions]="{}"
                >
                <dx-check-box data-testid="task-detail-check-box-1" [value]="markAsComplete" (onValueChanged)="onCompleteChanged($event)" [disabled]="!isEditable"></dx-check-box>
                <span style="padding-left:  10px; color:rgba(0,0,0,.6);">Mark As Complete</span>

              </dxi-item>
             <dxi-item
              [colSpan]="1"
                cssClass="user-button detail-submit"
                horizontalAlignment="right"
                editorType="dxButton"
                [editorOptions]="buttonCancelOptions"
              ></dxi-item>
              <dxi-item
              [colSpan]="1"
              cssClass="user-button"
              horizontalAlignment="right"
              editorType="dxButton"
              [editorOptions]="buttonEditorOptions"
            ></dxi-item>

            </dx-form>
          </form>
        </div> -->
      </div>

      <div *ngIf="section == 'Chat'" class="accordion-section-fill">
          <app-chat data-testid="chat" id="chat" #chats [task]="selectedTask" (taskCommentPostEmitter)="onChatCommentPosted($event)"></app-chat>
      </div>

      <div *ngIf="section == 'Task History'" class="accordion-section-fill">
        <app-task-history data-testid="task-history" [task]="selectedTask"></app-task-history>
      </div>

      <div *ngIf="section == 'Files'">
        <dxi-item [colSpan]="1">
          <ul>
            <li>File 1</li>
            <li>File 2</li>
            <li>File 3</li>
          </ul>


        </dxi-item>
      </div>
    </div>
  </dx-accordion>
</form>
<div data-testid="task-detail-mt-2" class="mt-2"></div>

</div>

<!-- Field Change Comment Popup -->
<dx-popup
    data-testid="field-change-comment-popup"
    height="auto"
    [width]="fieldChangePopupWidth"
    position="center"
    [showCloseButton]="false"
    [showTitle]="true"
    [title]="getFieldChangeCommentPopupTitle()"
    [(visible)]="fieldChangeCommentPopupVisible"
    contentTemplate="fieldChangeCommentContent"
    [hideOnOutsideClick]="false"
>
  <div *dxTemplate="let data of 'fieldChangeCommentContent'" data-testid="field-change-comment-popup-content">
    <app-field-change-comment
      data-testid="field-change-comment-component"
      [fieldName]="activePendingChange?.fieldKey"
      [oldValue]="activePendingChange?.oldValue"
      [newValue]="activePendingChange?.newValue"
      [formattedOldValue]="activePendingChange?.formattedOldValue"
      [formattedNewValue]="activePendingChange?.formattedNewValue"
      (closePanelEmitter)="onFieldChangeCommentCancel()"
      (onCommentSubmitEmitter)="onFieldChangeCommentSubmit($event)">
    </app-field-change-comment>
  </div>
</dx-popup>

<!-- Loading Panel for Save Action -->
<dx-load-panel
  data-testid="task-detail-save-load-panel"
  [position]="{ of: '.task-detail-header' }"
  [visible]="isSaving"
  [showPane]="true"
  [shading]="true"
  [showIndicator]="true"
  message="Saving changes..."
  width="100"
  height="100"
></dx-load-panel>

<!-- DevExtreme Tooltip for HTML description display -->
<dx-tooltip
  data-testid="task-detail-description-tooltip"
  target=".tooltip-trigger"
  [(visible)]="tooltipVisible"
  [hideOnOutsideClick]="true"
  (onShown)="onTooltipShown()"
  (onHiding)="onTooltipHiding()"
  position="top">
  <div *dxTemplate="let data of 'content'">
    <div [innerHTML]="getTaskTooltipSafeHtml()"
         style="max-width: 400px; padding: 10px;"
         class="description-tooltip-content"
         (mouseenter)="keepTooltipOpen()"
         (mouseleave)="hideTooltip()"
         #tooltipContainer></div>
  </div>
</dx-tooltip>
